'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSimpleColorpicker = require('react-simple-colorpicker');

var _reactSimpleColorpicker2 = _interopRequireDefault(_reactSimpleColorpicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var colorString = require('color-string');

var ColorPickerComponent = function (_React$Component) {
  _inherits(ColorPickerComponent, _React$Component);

  function ColorPickerComponent(props) {
    _classCallCheck(this, ColorPickerComponent);

    var _this = _possibleConstructorReturn(this, (ColorPickerComponent.__proto__ || Object.getPrototypeOf(ColorPickerComponent)).call(this, props));

    _this.state = {
      displayColorPicker: false,
      color: _this.props.defaultColor,
      wcolor: _this.props.defaultColor
    };

    _this.handleClick = function () {
      _this.setState({ displayColorPicker: !_this.state.displayColorPicker });
    };

    _this.handleClose = function () {
      _this.setState({ displayColorPicker: false });
    };

    _this.handleChange = function (color) {
      _this.setState({
        color: color,
        wcolor: color
      }, _this.updateColor());
    };

    _this.handleInputChange = function (event) {
      var val = event.target.value;
      if (val) {
        _this.setState({ wcolor: val });
        var validateColor = colorString.get(val);
        if (validateColor) {
          var s = validateColor.model;
          var c = s + '(' + validateColor.value[0] + ', ' + validateColor.value[2] + ', ' + validateColor.value[2] + ', ' + validateColor.value[3] + ')';
          _this.setState({
            color: c
          }, _this.updateColor());
        }
      }
    };

    _this.updateColor = function () {
      _this.props.changeColor(_this.props.name, _this.state.color);
    };

    _this.componentDidMount = function () {
      document.body.addEventListener('click', _this.clickOutside);
    };

    _this.componentWillUnmount = function () {
      document.body.removeEventListener('click', _this.clickOutside);
    };

    _this.clickOutside = function (event) {
      var cPickWrapper = _this.cPickWrapper.current;
      if (_this.state.displayColorPicker && !cPickWrapper.contains(event.target)) {
        _this.setState({
          displayColorPicker: false
        });
      }
    };

    _this.cPickWrapper = _react2.default.createRef();
    return _this;
  }

  _createClass(ColorPickerComponent, [{
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'div',
        { className: 'ip-cPick-wrapper ' + (this.state.displayColorPicker ? 'is-active' : ''), ref: this.cPickWrapper },
        _react2.default.createElement(
          'div',
          { className: 'ip-cPick-handleWrapper' },
          _react2.default.createElement(
            'div',
            { className: 'ip-cPick-handle', onClick: this.handleClick },
            _react2.default.createElement(
              'div',
              { className: 'ip-cPick-color', style: { backgroundColor: this.state.color } },
              this.state.displayColorPicker && _react2.default.createElement(
                'div',
                { className: 'ip-cPick-colorClose' },
                '\xD7'
              )
            )
          ),
          _react2.default.createElement('input', { className: 'ip-cPick-colorInp ip-textField', value: this.state.wcolor, onChange: this.handleInputChange })
        ),
        this.state.displayColorPicker ? _react2.default.createElement(
          'div',
          { className: 'ip-cPick' },
          _react2.default.createElement(_reactSimpleColorpicker2.default, { color: this.state.color, onChange: this.handleChange, opacitySlider: true })
        ) : null
      );
    }
  }]);

  return ColorPickerComponent;
}(_react2.default.Component);

exports.default = ColorPickerComponent;


//////////////////
// WEBPACK FOOTER
// ./src/components/objects/ColorPickerComponent.js
// module id = 268
// module chunks = 0 1